import {isFirmAssignableRole} from '@sollapay/enums';

import type {FirmMemberDTO} from '@sollapay/types';

/**
 * A Sollapay-managed account (e.g. `firm_support`) rather than one of the firm's own people —
 * the single source of truth for every "treat this row differently" decision in the team
 * feature (grouping, counting, the locked role chip). Distinct from `isFirmAssignableRole`
 * (an RBAC rule about who may grant/hold a role): that happens to agree with this today
 * because `firm_support` is the only such role, but the two questions are conceptually
 * independent and this is the name to reach for on the display/roster side.
 */
export function isSystemAccessMember(member: FirmMemberDTO): boolean {
  return !isFirmAssignableRole(member.roleKey);
}

/**
 * Members that count toward the firm's own roster — excludes Sollapay-managed accounts,
 * which still appear in the table but aren't the firm's own people.
 */
export function countableTeamMembers(members: FirmMemberDTO[]): FirmMemberDTO[] {
  return members.filter(member => !isSystemAccessMember(member));
}
